import { IdentityDto } from './../shared/identity.dto';

export class BindingDto {
  identity: IdentityDto;
  type: string;
  code: string;

  constructor(d?: BindingDto) {
    if (!d) {
      return;
    }

    this.identity = new IdentityDto(d.identity);
    this.type = d.type;
    this.code = d.code;
  }
}
